<template>
  <div id="app">
    <Layout></Layout>
  </div>
</template>

<script>
import Layout from "@/components/Layout"

export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>

<style>
:root{
  --red-deep: #EF4444;
  --red-light: #FF6B6B;
  --orange: #F97316;
}

#app {
  color: #2c3e50;
  max-width: 540px;
  margin: 0 auto;
}

* {
  box-sizing: border-box;
}

p {
  margin: 0;
  padding: 0;
}
</style>
